import styled from '@emotion/styled';
import AddIcon from '@mui/icons-material/Add';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Stack } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PageStats,
  ScrollableTabs,
  WsButton,
  WsColors,
  WsIconText,
  WsTitleBanner,
  WsTypoColors,
} from 'wisestep-base';

import ConsultantsListingPage from './components/Consultants';
import HotJobsListing from './components/HotJobs';

export const LayoutTheme = styled(Box)(() => ({
  maxWidth: '100%',
  maxHeight: 'xs',
  backgroundColor: WsColors.TertiaryShades50,
}));

const LandingPage = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [noteMessage, setNoteMessage] = useState(true);
  const navigate = useNavigate();

  const renderPage = () => {
    if (currentTab === 0) return <HotJobsListing />;
    else return <ConsultantsListingPage />;
  };

  return (
    <LayoutTheme>
      <Stack spacing={2}>
        <WsTitleBanner
          title={currentTab === 0 ? 'Hot Jobs' : 'Bench Consultants'}
          rightChildren={
            <Stack direction="row" spacing={3}>
              {currentTab === 0 ? (
                <>
                  <PageStats statValue={0} statTitle="Jobs Sourced" />
                  <PageStats statValue={0} statTitle="Days" />
                  <PageStats statValue={0} statTitle="Emails Sent" />
                </>
              ) : (
                <>
                  <WsButton variant="text">Import History</WsButton>
                  <WsButton
                    startIcon={<AddIcon />}
                    onClick={() => navigate('/consultant/uploads')}
                    fullWidth={false}
                    size="small"
                  >
                    Add/Import Consultants
                  </WsButton>
                </>
              )}
            </Stack>
          }
          backButton={false}
        />

        {noteMessage && (
          <Box
            sx={{
              backgroundColor: WsColors.TheBlues900,
              height: '3rem',
              width: '100%',
              borderRadius: 1.5,
              padding: 4,
            }}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <WsIconText
              icon={<InfoOutlinedIcon color="secondary" />}
              text="Market your Consultants for the latest jobs without any need to import your candidate vendor list."
              textColor={WsTypoColors.PRIMARY200}
            />
            <WsButton onClick={() => setNoteMessage(false)}>Okay</WsButton>
          </Box>
        )}

        <ScrollableTabs
          scrollList={[{ tabName: 'Hot Jobs' }, { tabName: 'Consultants' }]}
          getTabIndex={(index: number) => setCurrentTab(index)}
          defaultValue={0}
        />

        <Box>{renderPage()}</Box>
      </Stack>
    </LayoutTheme>
  );
};

export default LandingPage;
